import { createTrackingUtils } from "../index.js";
import useMdotValueTrackDefaultStages, { MDotValueStage } from "./default_stages.js";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { useEffect } from "react";
const EXP_NAME = "flights_mdotvalue_sr_sticky_search_box";
const expState = {
    isSearchBoxSticky: false
};
export const tracking = createTrackingUtils({
    name: EXP_NAME,
    defaultStage: 1,
    stages: {
        eligible: 1,
        on_view: 2,
        scroll_to_third: 3,
        scroll_to_fifth: 4,
        reached_page_end: 5,
        [MDotValueStage.PAID_TRAFFIC]: 6,
        [MDotValueStage.US_TRAFFIC]: 7,
        [MDotValueStage.KEY_MARKET_TRAFFIC]: 8,
        [MDotValueStage.DIRECT_TRAFFIC]: 9
    },
    goals: {
        flights_search_box_open: 1,
        flights_sticky_search_box_open: 2,
        reached_page_end: 3
    }
});
export function useStickySearchBoxExp(isSearchboxSticky = expState.isSearchBoxSticky) {
    const { isMobile } = useUserAgent();
    const trackDefaultStages = useMdotValueTrackDefaultStages();
    useEffect(() => {
        if (!isMobile || isSearchboxSticky === expState.isSearchBoxSticky) {
            return;
        }
        expState.isSearchBoxSticky = isSearchboxSticky;
        if (isSearchboxSticky && isMobile) {
            tracking.stages.on_view();
            trackDefaultStages(tracking.stages);
        }
    }, [isMobile, isSearchboxSticky, trackDefaultStages]);
    const trackScrollToThird = () => {
        if (expState.isSearchBoxSticky && isMobile) {
            tracking.stages.scroll_to_third();
        }
    };
    const trackScrollToFifth = () => {
        if (expState.isSearchBoxSticky && isMobile) {
            tracking.stages.scroll_to_fifth();
        }
    };
    const getVariant = () => {
        if (isMobile) {
            return tracking.trackWithDefaultStage();
        }
        return 0;
    };
    const trackFlightsSearchBoxOpen = () => {
        if (!isMobile) {
            return;
        }
        tracking.goals.flights_search_box_open();
        if (expState.isSearchBoxSticky) {
            tracking.goals.flights_sticky_search_box_open();
        }
    };
    const trackReachedEndOfPage = () => {
        if (!isMobile) {
            return;
        }
        tracking.goals.reached_page_end();
        tracking.stages.reached_page_end();
    };
    return {
        trackScrollToThird,
        trackScrollToFifth,
        getVariant,
        trackFlightsSearchBoxOpen,
        trackReachedEndOfPage
    };
}
